export default __webpack_public_path__ + "static/c1-f7f91e994716ab4676e2ea3c2c354af5.png";